import app from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';

const firebaseConfig = {
    apiKey: "AIzaSyCiSAGP_1ydcJhNTIXLW-lZzHzkm-0WQB0",
    authDomain: "yomi-korea.firebaseapp.com",
    databaseURL: "https://yomi-korea.firebaseio.com",
    projectId: "yomi-korea",
    storageBucket: "yomi-korea.appspot.com",
    messagingSenderId: "294908653810",
    appId: "1:294908653810:web:d30d34a8c288973546a06b",
    measurementId: "G-S834ZGW9MW"
};

/*

class Firebase {
    constructor() {
        app.initializeApp(config);


        this.fieldValue = app.firestore.FieldValue;
        this.emailAuthProvider = app.auth.EmailAuthProvider;


        this.auth = app.auth();
        this.firestore = app.firestore();

    }

}

export default Firebase;
*/


const firebaseApp = app.initializeApp(firebaseConfig);
const firebaseAuth = firebaseApp.auth();
const firebaseFirestore = firebaseApp.firestore();
const firebaseStorage = firebaseApp.storage();


export {firebaseApp, firebaseAuth, firebaseFirestore, firebaseStorage};
